import { GlobalEnvironment } from '@global/interfaces/global-environment.interface';

export const environment: GlobalEnvironment = {
  production: true,
  debug: true,
};
